import React from "react"
import _includes from "lodash/includes"
import PropTypes from "prop-types"
import classnames from "classnames"

import ThemeConsumer from "shared/components/ThemeConsumer"
import ModernButton from "shared/components/Button/ModernButton"

import ContainerGradient from "components/ContainerGradient"
import Typograph from "components/Typograph"

const Banner = ({
  buttonText,
  buttonSize,
  buttonType,
  buttonColor,
  children,
  className,
  gradientColor,
  id,
  icons,
  iconName,
  linkText,
  onClick,
  textButtonColor,
  theme,
  classNames
}) => {
  const hasGrid3of9 = _includes(className, "u-size3of9")
  const bannerClasses = classnames(
    "u-flex u-flexJustifyBetween",
    theme.mt5,
    theme.banner,
    { [theme.pa4]: hasGrid3of9, [theme.pa6]: !hasGrid3of9 },
    classNames
  )

  const buttonClasses = classnames(theme.px13)

  const IconComponent = icons[iconName] || null

  return (
    <ContainerGradient
      classNames={classnames(bannerClasses, className)}
      color={gradientColor}
      atPosition="D"
    >
      <div>
        {children}
        {linkText && (
          <Typograph
            htmlTag="a"
            preset="link"
            size="small"
            weight="medium"
            onClick={onClick}
            id={id}
          >
            {linkText}
          </Typograph>
        )}
      </div>
      {buttonText && (
        <ModernButton
          classNames={buttonClasses}
          withBorderRadius
          size={buttonSize}
          type={buttonType}
          buttonColor={buttonColor}
          textColor={textButtonColor}
          text={buttonText}
          onClick={onClick}
          id={id}
        />
      )}
      {IconComponent && <IconComponent />}
    </ContainerGradient>
  )
}

Banner.propTypes = {
  buttonSize: PropTypes.string,
  buttonType: PropTypes.string,
  buttonColor: PropTypes.string,
  textButtonColor: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gradientColor: PropTypes.string.isRequired,
  id: PropTypes.string,
  icons: PropTypes.object,
  iconName: PropTypes.string,
  linkText: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.object,
  classNames: PropTypes.string
}
Banner.defaultProps = {
  buttonText: "",
  gradientColor: "",
  onClick: () => {}
}

export default ThemeConsumer("UIBanner")(Banner)



// WEBPACK FOOTER //
// ./src/shared/components/Banner/index.js